import { AxiosInstance } from "axios";
import {
  IFilterSchema,
  IListQueryStringSchema,
  ISortSchema,
} from "../../Schemas/ListQueryString";
import { IResponseBody } from "../../Schemas/EndPoint";
import { PaymentAdminSchema } from "../../Schemas/Payment";

interface Filter extends IFilterSchema {
  column: PaymentAdListColumnFilterable;
}

interface Sort extends ISortSchema {
  column: PaymentAdListColumnSortable;
}

export enum PaymentAdVerifyingStatusEnum {
  PENDING = "pending",
  PAYING = "paying",
  PAID = "paid",
  FAILED = "failed",
}

export enum PaymentAdListColumnFilterable {
  USER_ID = "user_id",
  ID = "id",
  NAME = "name",
  CAPTION = "caption",
  DISK = "disk",
  TYPE = "type",
  SIZE = "size",
  LENGTH = "length",
  VERIFYING_STATUS = "verifying_status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
  PAYMENT_GATEWAY_ID = "payment_gateway_id",
}
export enum PaymentAdListColumnSortable {
  ID = "id",
  NAME = "name",
  CAPTION = "caption",
  DISK = "disk",
  TYPE = "type",
  SIZE = "size",
  LENGTH = "length",
  VERIFYING_STATUS = "verifying_status",
  UPDATED_AT = "updated_at",
  CREATED_AT = "created_at",
}

interface PaymentListQueryString extends IListQueryStringSchema {
  filters?: Filter[];
  sorts?: Sort[];
}

interface PaymentListResponseBody extends IResponseBody {
  data: {
    payment_receipts: PaymentAdminSchema[];
    total: number;
  };
}

export class PaymentAdminListRequest {
  private protectedAxiosInstance: AxiosInstance;

  constructor(protectedAxiosInstance: AxiosInstance) {
    this.protectedAxiosInstance = protectedAxiosInstance;
  }

  private getPath() {
    return `/admin/payment-receipts`;
  }

  async send(
    queryStrings?: PaymentListQueryString
  ): Promise<PaymentListResponseBody> {
    try {
      const { data } = await this.protectedAxiosInstance.get(this.getPath(), {
        params: queryStrings,
      });
      return data;
    } catch (err) {
      // TODO : handle error
      throw err;
    }
  }
}
